import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Upload, Button, Icon, message } from 'antd';
import Loading from '$app/shared/components/Loading';
import { api } from '$app/api';

import { uploadToS3 } from './actions';

const LicensePhotoUpload = ({ ownerId, side }) => {
  const [target, setTarget] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleDrivingLicenseUpload = async (_target) => {
      let fileName;
      try {
        const { file } = _target;
        if (file && file.originFileObj && loading) {
          const { originFileObj } = file;
          fileName = originFileObj.name;
          const { data: signedUrlData } = await api.post('/media/signed-url', {
            ownerType: 'driver',
            ownerId,
            mediaType: originFileObj.type,
            mediaName: `${originFileObj.name}_${side}`,
            privateBucket: true,
          });
          const { uploadUrl, id } = signedUrlData;
          const uploadResult = await uploadToS3({
            uploadUrl,
            file: originFileObj,
            options: {
              headers: {
                'Content-Type': originFileObj.type,
              },
            },
          });

          if (uploadResult && uploadResult.status === 200) {
            await api.patch(`/media/${id}`, { status: 'success' });
          }
          setLoading(false);
          setTarget(null);
          message.success(`${fileName} uploaded`);
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
        setTarget(null);
        message.error(`${fileName} upload failed`);
      }
    };

    if (target && loading) {
      handleDrivingLicenseUpload(target);
    }
  }, [loading, ownerId, side, target]);

  return (
    <>
      {loading && (
        <div style={{ width: 60 }}>
          <Loading />
        </div>
      )}
      {!loading && (
        <Upload
          name="file"
          showUploadList={false}
          onChange={(_target) => {
            if (!target) {
              setTarget(_target);
              setLoading(true);
            }
          }}
        >
          <Button>
            <Icon type="upload" /> Click to Upload
          </Button>
        </Upload>
      )}
    </>
  );
};

LicensePhotoUpload.propTypes = {
  ownerId: PropTypes.string.isRequired,
  side: PropTypes.string.isRequired,
};

export default LicensePhotoUpload;
